import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '/store/RootState';

import { ICalendarSetTimeIteratorPayload, initialCalandarState } from './state';

const calendarSlice = createSlice({
  name: 'calendar',
  initialState: initialCalandarState,
  reducers: {
    setTimeIterator: (state, action: PayloadAction<ICalendarSetTimeIteratorPayload>) => {
      const { key, timeIterator } = action.payload;
      state[key] = timeIterator;
    },
  },
});

export const calendarToolkit = Object.freeze({
  initialState: initialCalandarState,
  actions: calendarSlice.actions,
  selectors: {
    experimentsTimeIterator: (state: RootState) => state.calendar.experimentsTimeIterator,
    gameEventsTimeIterator: (state: RootState) => state.calendar.gameEventsTimeIterator,
  },
});

export const calendarReducer = calendarSlice.reducer;
